import { Box, styled } from '@mui/material';

export const NoShowKpiSection = styled(Box)(() => ({
  width: '432px',
  height: '245px',
  flexShrink: 0,
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '8px',
  backgroundColor: '#FFFFFF',
  overflow: 'hidden',
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.03)',
}));

export const NoShowKpiHeader = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '14px 16px',
  color: '#9EA2A2',
  backgroundColor: '#FFFFFF',
}));

export const NoShowKpiTitle = styled('span')(() => ({
  fontFamily: 'Montserrat, sans-serif',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '20px',
  color: '#9EA2A2',
}));

export const NoShowKpiChartContainer = styled(Box)(() => ({
  flex: 1,
  minHeight: 0,
  paddingBottom: '12px',
  backgroundColor: '#FFFFFF',
}));

export const TooltipContainer = styled(Box)(() => ({
  backgroundColor: '#FFFFFF',
  borderRadius: '5px',
  boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
  padding: '10px 14px',
  minWidth: '180px',
  fontFamily: 'Montserrat, sans-serif',
}));

export const TooltipTitle = styled('div')(() => ({
  fontSize: '12px',
  fontWeight: 600,
  color: '#303C42',
  marginBottom: '6px',
}));

export const TooltipRow = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '12px',
  fontSize: '12px',
  color: '#303C42',
  padding: '2px 0',
}));
